import { GET_PROCESS_EXPORT_CSV_FILE, GET_IMPORT_CSV_CONTENT } from "./types";

export default {
  [GET_PROCESS_EXPORT_CSV_FILE]: (state) => state.exportCsv,
  [GET_IMPORT_CSV_CONTENT]: (state) => state.importCsv.csv_content,
};
